import { forwardRef } from "react";
import { useTranslation } from "react-i18next";
import { FormFieldLabel } from "@/components/form/field/label";
import type { AppFormFieldPartProps } from "@/form/components/types";

export type AppFormFieldLabelProps = {
  /** Used as a translation key for the label */
  name?: string;
};

export const AppFormFieldLabel = forwardRef<
  HTMLIonLabelElement,
  React.ComponentProps<typeof FormFieldLabel> & AppFormFieldPartProps & AppFormFieldLabelProps
>(function AppFormFieldLabel({ field, name, ...props }, ref) {
  const { t } = useTranslation();

  return (
    <FormFieldLabel ref={ref} {...props}>
      {t(`fields:${name ?? field.name}.label`)}
    </FormFieldLabel>
  );
});
